<template>
  <div
      v-show="isShow"
      class="select_tool"
      :class="`select_tool-${navbarStatus}`"
  >
    <div class="select_tool--buffer"></div>
    <ul>
      <li
          v-for="item in selectList"
          :key="item.value"
          @click="handleClick(item)"
      >
        {{ item.label }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SelectTool',
  props: {
    selectList: {
      required: true,
      type: Array,
      default: () => []
    },
    isShow: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['navbarStatus'])
  },
  methods: {
    handleClick(item) {
      this.$emit('changeSelect', item);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$NavItemColor: rgb(237,238,240);
$NavItemColorActive: rgb(175,179,186);
$ButtonBackColor: #3451e2;
.select_tool{
  position: absolute;
  top: 3.5rem;
  left: -1rem;
  .select_tool--buffer{
    width: 100%;
    height:0.2rem;
    background-color: transparent;
  }
  ul{
    border-radius: 5px;
    list-style: none;
    width: 6.7rem;
    text-align: left;
    padding: 0.1rem 0.2rem;
    li{
      height: 2rem;
      line-height: 2rem;
      padding: 0 0.5rem;
    }
  }
}
.select_tool-black{
  background-color: rgba(0,0,0,.1);
  ul{
    background-color: rgb(24, 25, 27);
    li{
      color: $NavItemColor;
      &:hover{
        background-color: rgb(33, 34, 37);
      }
    }
  }
}
.select_tool-white{
  background-color: rgba(255,255,255,.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  ul{
    background-color: rgb(255,255,255);
    li{
      color: rgb(0, 0, 0);
      &:hover{
        background-color: rgb(237,238,240);
      }
    }
  }
}
</style>
